import {useContext} from 'react';

import {FormsDataContext} from '../contexts';

/**
 * Hook that provides access to the global forms data context throughout the component tree.
 * This hook returns the current context value from FormsDataContext, allowing components to read and interact with form state.
 * It serves as a convenient wrapper around useContext for accessing the global form management system.
 *
 * @returns The current FormsDataContext value containing global form state and methods.
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const formContext = useGlobalFormContext();
 *
 *   return (
 *     <div>
 *       {formContext && <span>Form data available</span>}
 *     </div>
 *   );
 * };
 * ```
 */
export const useGlobalFormContext = () => useContext(FormsDataContext);